export enum ClientMessagesStatusEnum {
    'ACTIVE' = 49, // 1
    'CANCELLED' = 50, // 2
    'DECLINED' = 51, // 3
    'DISPLAYABLE' = 52, // 4
    'ENDED' = 53, // 5
    'PENDING' = 54 // 6
}

export enum ClientMessagesTypeEnum {
    'ADVISORY' = 65, // A
    'BANNER' = 66 // B
}

export const ClientMessagesStatusMap = {
    49: 'Active',
    50: 'Canceled',
    51: 'Declined',
    52: 'Displayable',
    53: 'Ended',
    54: 'Pending'
};

export const ClientMessagesTypeMap = {
    65: 'Advisory',
    66: 'Banner'
};